import React, { useEffect, useRef, useState } from "react";
import Button from "../../../components/common/ui/Button";
import {
  CheckBoxInput,
  RadioInput,
  TextAreaInput,
  TextInput,
} from "../../../components/common/ui/Inputs";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../../_helpers";
import { useLocation } from "react-router-dom";
import {
  facilityAction,
  masterActions,
  staffRequestAction,
} from "../../../_store";
import CustomLoader from "../../../components/common/ui/Loader";
import { Popup } from "../../../components/common/ui/NotificationModal/Popup";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import FormHeader from "./FormHeader";
import {
  MenuItem,
  SubMenuItem,
  UserRoleType,
} from "../../../_helpers/enumerator";
import { handleReviewRequestFormNavigation } from "./ReviewRequestFormNavigator";

function VisitorRequestForm() {
  const componentRef = useRef();
  const location = useLocation();
  const dispatch = useDispatch();

  const formID = location?.state ? location?.state?.formID : 0;
  const formDetails = location?.state ? location?.state?.formDetails : [];
  const sourceFrom = location?.state ? location?.state?.sourceFrom : "";

  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const { ApproveAction } = useSelector((x) => x.dropdownOptions);
  const {
    visitorInfo,
    visitorRequestFormUpdate,
    formUpdateResponse,
    requestReview,
    legalRequestFormAccess: visitorRequestFormAccess,
    indexValue,
    staffRequestSearchList,
    staffRequestList,
    loading,
  } = useSelector((x) => x?.staffRequest);

  const { GetFacilityStaffReqInfoResponse, loading: facilityLoader } =
    useSelector((x) => x?.facility);
  const { user } = useSelector((x) => x.auth);
  const RequestFormType = location?.state
    ? location?.state?.RequestFormType
    : 0;
  const staffRequestID = parseInt(process.env.REACT_APP_STAFF_REQUEST_ACCESSIBLE_FA, 10);
  const STAFF_REQUEST_ACCESSIBLE_FA = [staffRequestID];

  const managementUserID = user?.ManagementUserID;
  const userRoleID = user?.UserRoleID;
  const loggedUserName = user?.FullName;

  // const [facilityName, setFacilityName] = useState("");
  const [showBtn, setShowBtn] = useState(true);

  const [submittedFormList, setSubmittedFormList] = useState([]);

  const [maxApprovedCount, setMaxApprovedCount] = useState(6);

  const prevFacilityCodeRef = useRef(facilityCode);

  const [errorMessage, setErrorMessage] = useState({});

  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, []);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate(sourceFrom);
    }
  }, [facilityCode]);

  useEffect(() => {
    if (formID === 0) {
      history?.navigate("StaffRequestList");
      return;
    }
    dispatch(staffRequestAction?.getVisitorInformation(formID));
    dispatch(staffRequestAction?.getVisitorDetails(formID))
      .then((result) => {
        if (facilityCode === 10) {
          setMaxApprovedCount(8);
        } else if (facilityCode === 25) {
          setMaxApprovedCount(4);
        } else {
          setMaxApprovedCount(6);
        }
        const visitorData = { ...visitorRequestFormUpdate };
        const visitorFormDetails = result?.payload;
        visitorData.requestVisitorFormID = formID;
        visitorData.facilityID = facilityCode;
        visitorData.inmateID = visitorInfo?.InmateID;
        visitorData.typ_ReqVisitorInfoRespond = visitorFormDetails;
        dispatch(staffRequestAction?.updateVisitorRequestFormData(visitorData));
      })
      .catch((err) => { });
    dispatch(
      facilityAction?.GetFacilityStaffReqInfo({ facilityID: facilityCode })
    );
  }, [location?.state?.formID]);

  useEffect(() => {
    switch (formUpdateResponse?.IsSucceed) {
      case 1:
        if (!requestReview) {
          history?.navigate("/Admin/StaffRequestList");
        }

        showToastNotification(
          "Visitor information updated successfully",
          "success"
        );
        dispatch(
          staffRequestAction?.UpdateMURequestRead({
            requestID: formID,
            requestFormTypeID: RequestFormType,
            facilityID: facilityCode,
            createdBy: managementUserID,
          })
        );
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: managementUserID,
            FacilityID: facilityCode,
          })
        );

        if (requestReview) {
          //admin
          const searchData = { ...staffRequestSearchList };
          searchData.PageNo = 1;
          searchData.RowCountPerPage = staffRequestList?.TotalRecordCount;
          searchData.FacilityID = facilityCode;
          searchData.ManagementUserID = managementUserID;
          dispatch(staffRequestAction?.LoadRequestReviewAllList(searchData))
            .then((result) => {
              if (result?.payload?.DataList?.length > 0) {
                const data = result?.payload;
                handleReviewRequestFormNavigation(
                  "next",
                  data,
                  indexValue,
                  history,
                  sourceFrom,
                  dispatch
                );
              } else {
                history?.navigate("/Admin/StaffRequestList");
              }
            })
            .catch((err) => {
              showToastNotification(err?.message, "error");
            });
        }

        // const searchList = {
        //   ...staffRequestSearchList,
        //   PageNo: 1,
        //   RowCountPerPage: 10,
        //   FacilityID: facilityCode,
        // };
        // dispatch(staffRequestAction?.setStaffRequestSearchList(searchList));

        dispatch(staffRequestAction?.resetForm());

        const formList = [...submittedFormList];
        formList.push(formID);
        setSubmittedFormList(formList);
        break;

      case -2:
        showToastNotification(
          "Data Table have no data (Request Visitor List)",
          "error"
        );
        dispatch(staffRequestAction?.resetForm());
        break;

      case 0:
        showToastNotification("Operation Failed", "error");
        dispatch(staffRequestAction?.resetForm());
        break;

      default:
        break;
    }
  }, [formUpdateResponse]);

  useEffect(() => {
    if (
      userRoleID === UserRoleType?.SuperAdmin ||
      STAFF_REQUEST_ACCESSIBLE_FA?.includes(managementUserID) ||
      visitorRequestFormAccess?.FormRespond === 1
    ) {
      setShowBtn(true);
      // return;
    } else {
      dispatch(
        staffRequestAction?.GetManagementUserAccessPermission({
          ManagementUserID: managementUserID,
          ManagementMenuID: MenuItem?.RequestsOrGrievancesMenuItem,
        })
      )
        .then((result) => {
          const data = result?.payload;
          if (
            data?.length > 0 &&
            data?.[1]?.SubMenuID === SubMenuItem?.RespondSubMenuItem &&
            data?.[1]?.SubMenuActiveStatus === 1
          ) {
            setShowBtn(true);
          }
        })
        .catch((err) => {
          showToastNotification("Failed to get Access data", "error");
        });
    }
  }, []);

  useEffect(() => {
    if (RequestFormType > 0) {
      dispatch(
        staffRequestAction?.getRequestFormAccess({
          ManagementUserID: managementUserID,
          // formID: RequestFormType,
          formID:
            RequestFormType > 0
              ? RequestFormType
              : formDetails?.DataList?.[indexValue]?.RequestFormType,
          FacilityCode: facilityCode,
        })
      )
        .then((result) => {
          const data = result?.payload;
          if (data?.FormRespond === 0) {
            setShowBtn(false);
          } else {
            setShowBtn(true);
          }
        })
        .catch((err) => {
          showToastNotification("Failed to get permission data", "error");
        });
    }
  }, [
    RequestFormType,
    dispatch,
    facilityCode,
    formDetails?.DataList,
    indexValue,
    managementUserID,
  ]);

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
       size: A4 portrait;
        margin: 2 !important;
         padding: 2 !important;
      }
body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  `,
    content: () => componentRef.current,
    onBeforeGetContent: () => { },
  });

  const handleSubmit = (e) => {
    let approvedCount = 0;
    e?.preventDefault();

    //validation
    let shouldDispatch = true;

    visitorRequestFormUpdate?.typ_ReqVisitorInfoRespond?.map((item) => {
      if (item?.RequestVisitorStatusId === 1) {
        approvedCount += 1;
      }

      if (item?.RequestVisitorStatusId === 2) {
        shouldDispatch = false;
        Popup({
          title: "Message",
          text: `Please fill needed information in visitor list.`,
          icon: "warning",
          confirmButtonText: "Ok",
        });
      }

      if (item?.RequestVisitorStatusId === 0) {
        if (
          item?.IsAddressIncomplete === 0 &&
          item?.IsFormerInmate === 0 &&
          item?.IsVistorVictim === 0 &&
          !item?.ReqDisApprovedReason
        ) {
          shouldDispatch = false;
          Popup({
            title: "Message",
            text: `Please fill needed information in visitor list.`,
            icon: "warning",
            confirmButtonText: "Ok",
          });
        }
      }
    });

    if (approvedCount > maxApprovedCount) {
      Popup({
        title: "Message",
        text: `Maximum Visitor limits is ${maxApprovedCount}`,
        icon: "warning",
        confirmButtonText: "Ok",
      });
      return;
    }
    if (shouldDispatch) {
      dispatch(
        staffRequestAction?.updateVisitorRequestForm({ ...visitorRequestFormUpdate, inmateID: visitorInfo?.InmateID })
      );
    }
  };

  const handleApproveChange = (e, i) => {
    const { value } = e.target;
    // visitorRequestFormUpdate?.typ_ReqVisitorInfoRespond
    const updatedVisitorData = {
      ...visitorRequestFormUpdate,
      typ_ReqVisitorInfoRespond:
        visitorRequestFormUpdate.typ_ReqVisitorInfoRespond.map((item, index) =>
          index === i
            ? {
              ...item,
              RequestVisitorStatusId: parseInt(value),
              // IsAddressIncomplete: 0,
              // IsFormerInmate: 0,
              // IsVistorVictim: 0,
              // ReqDisApprovedReason: "",
            }
            : item
        ),
    };
    dispatch(
      staffRequestAction?.updateVisitorRequestFormData(updatedVisitorData)
    );
  };

  const handleDisapproval = (e, i) => {
    const { name, checked, type, value } = e.target;
    const regex = /^[a-zA-Z0-9_.,?!\s]*$/;
    if (!regex.test(value)) return;

    const updatedVisitorData = {
      ...visitorRequestFormUpdate,
      typ_ReqVisitorInfoRespond:
        visitorRequestFormUpdate.typ_ReqVisitorInfoRespond.map((item, index) =>
          index === i
            ? {
              ...item,
              [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
            }
            : item
        ),
    };
    dispatch(
      staffRequestAction?.updateVisitorRequestFormData(updatedVisitorData)
    );
  };

  if (loading || facilityLoader) return <CustomLoader />;

  return (
    <>
      <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
        <FormHeader
          list={formDetails}
          requestReview={requestReview}
          handlePrints={handlePrints}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
        />
        <div className="request-remedy-form">
          <div className="">
            <form onSubmit={(e) => handleSubmit(e)}>
              <div className="" ref={componentRef}>
                <article>
                  <div className="d-flex flex-wrap align-items-center profile-row mb-4">
                    <div className="d-flex req-header-img">
                      {GetFacilityStaffReqInfoResponse?.LogoFile && (
                        <img
                          src={
                            "data:image/png;base64," +
                            GetFacilityStaffReqInfoResponse?.LogoFile
                          }
                          alt="facility-logo"
                          className="req-img"
                        />
                      )}
                    </div>
                    <div className="justify-content-center align-items-center req-header-title">
                      <h3 className="text-color py-2 text-center">
                        <span className="label-red req-text">
                          {GetFacilityStaffReqInfoResponse?.FacilityName}
                        </span>
                      </h3>
                    </div>
                  </div>
                  <h4
                    className="request-form-header text-color mt-4"
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa-solid fa-user me-2"></i> VISITOR
                    INFORMATION
                  </h4>

                  <div className="m-1 row border-bottom-1 request-form-card ">
                    <h4
                      className="request-form-header text-color mt-4"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa-solid fa-user me-2"></i> INMATE
                      INFORMATION
                    </h4>
                    {[
                      {
                        label: "Date",
                        value: visitorInfo?.RequestCreateDate,
                      },
                      {
                        label: "ID",
                        value: visitorInfo?.InmateResidentId,
                      },
                      {
                        label: "Name",
                        value: visitorInfo?.InmateFullName,
                      },
                      { label: "POD", value: visitorInfo?.PodCode },
                    ].map((item, index) => (
                      <div key={index} className="col-sm-12 col-md-6">
                        <div className="user-information d-flex flex-wrap align-items-center">
                          <div className="fs-5 p-2  value-info">
                            {item.label}
                          </div>
                          <div className="p-1">:</div>
                          <div className="fs-5 p-2 text-start fw-bold value-text">
                            {item.value || "-"}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <h4
                    className="inner-header-bg text-color mt-4"
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa-solid fa-address-card me-2"></i> VISITOR
                    DETAILS
                  </h4>
                  {visitorRequestFormUpdate?.typ_ReqVisitorInfoRespond?.map(
                    (item, index) => (
                      <div
                        className={`row visitors-list visitors-panel-inner ${index % 2 === 1 ? "visitor-request-form mt-2" : "mt-2"
                          }`}
                      >
                        <div className="col-lg-12">
                          {item?.RequestVisitorStatus === "New" && (
                            <div class="newbutton-container mt-2">
                              New
                              <div class="border-animation"></div>
                            </div>
                          )}
                        </div>

                        <div>
                          <div className="details-legal d-flex flex-wrap gap-7">
                            <div className=" fw-600 fs-3  text-black">
                              Action
                            </div>
                            <div className="fw-bold d-flex flex-wrap justify-content-center align-items-center ">
                              <RadioInput
                                name={`ReqApproved_${index}`}
                                id={`ReqApproved_${index}`}
                                options={ApproveAction}
                                handleChange={(e) =>
                                  handleApproveChange(e, index)
                                }
                                selectedValue={item?.RequestVisitorStatusId}
                                disabled={
                                  visitorRequestFormAccess?.FormRespond === 0
                                }
                              />
                            </div>
                          </div>

                          <div className="details-legal">
                            <div className="row ">
                              {[
                                { label: "Name", value: item?.VisitorName },
                                { label: "DOB", value: item?.DOB },
                                {
                                  label: "Relation",
                                  value: item?.Relation,
                                },
                                {
                                  label: "Phone Number",
                                  value: item?.PhoneNo,
                                },
                                {
                                  label: "Address",
                                  value: item?.StreetName,
                                },
                                { label: "City", value: item?.City },
                                { label: "State", value: item?.StateName },
                                { label: "ZIP", value: item?.ZIP },
                              ].map((item, index) => (
                                <div key={index} className="col-sm-12 col-md-4">
                                  <div className="user-information d-flex flex-wrap align-items-center">
                                    <div className="fs-5 p-2  value-info">
                                      {item.label}
                                    </div>
                                    <div className="p-1">:</div>
                                    <div className="fs-5 p-2 text-start fw-bold value-text">
                                      {item.value || "-"}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            {visitorRequestFormAccess?.FormRespond === 1 &&
                              item?.ReqApproved === 3 && ( //need to change this condition when approval sec is needed (item?.ReqApproved === 1)
                                <div className="">
                                  <h4
                                    className="inner-header-bg text-color mt-4"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i class="fa-solid fa-thumbs-up"></i>{" "}
                                    APPROVAL SECTION
                                  </h4>
                                  <TextInput
                                    label="Your Request has been APPROVED BY"
                                    name="approvedBy"
                                    value={
                                      item?.ReqModifiedMUBy
                                        ? item?.ReqModifiedMUBy
                                        : loggedUserName
                                    }
                                    maxLength={30}
                                    disabled
                                    readonly
                                    parentClassName={
                                      "d-flex flex-wrap align-items-center gap-2"
                                    }
                                    labelClassName={"w-auto"}
                                  />
                                </div>
                              )}

                            {!item?.RequestVisitorStatusId &&
                              visitorRequestFormAccess?.FormRespond === 1 && (
                                <div className="">
                                  <h4
                                    className="inner-header-bg text-color mt-4"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i class="fa-solid fa-thumbs-down me-2"></i>{" "}
                                    DISAPPROVAL SECTION
                                  </h4>

                                  <div>
                                    <CheckBoxInput
                                      label="Address is incomplete. Complete physical address is required."
                                      name="IsAddressIncomplete"
                                      id={`IsAddressIncomplete-${index}`}
                                      handleClick={(e) =>
                                        handleDisapproval(e, index)
                                      }
                                      checked={item?.IsAddressIncomplete === 1}
                                    />
                                    <CheckBoxInput
                                      label="The requested visitor is former inmate"
                                      name="IsFormerInmate"
                                      id={`IsFormerInmate-${index}`}
                                      // id="IsFormerInmate"
                                      handleClick={(e) =>
                                        handleDisapproval(e, index)
                                      }
                                      checked={item?.IsFormerInmate === 1}
                                    />
                                    <CheckBoxInput
                                      label="The requested visitor is the victim"
                                      name="IsVistorVictim"
                                      // id="IsVistorVictim"
                                      id={`IsVistorVictim-${index}`}
                                      handleClick={(e) =>
                                        handleDisapproval(e, index)
                                      }
                                      checked={item?.IsVistorVictim === 1}
                                    />
                                    <TextAreaInput
                                      label="Others"
                                      name="ReqDisApprovedReason"
                                      handleChange={(e) =>
                                        handleDisapproval(e, index)
                                      }
                                      value={item?.ReqDisApprovedReason}
                                      maxLength={500}
                                      rows={2}
                                    />
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </article>
              </div>

              {showBtn && !submittedFormList?.includes(formID) && (
                <div className="pb-3 mt-4 gap-3 d-flex flex-wrap justify-content-center align-items-center">
                  <Button
                    label="Update"
                    status="success"
                    type="submit"
                    icon={"fa-solid fa-pen-to-square"}
                  />
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(VisitorRequestForm);
